import Icon from '@mdi/react';
import { Tooltip } from '@mui/material';
import React from 'react';
import { Row } from 'react-table';
import { TooltipTransitionComponent } from '../../../base';
import * as S from './row-actions.styles';

export interface IRowAction<D extends object = any> {
    icon: string; // mdi icon path
    tooltip: string;
    action: (row: Row<D>) => void;
    isVisible?: (row: Row<D>) => boolean;
    isDisabled?: (row: Row<D>) => boolean;
}

export interface IRowActionsProps<D extends object = any> {
    row: Row<D>;
    actions: IRowAction<D>[];
    isVisible?: boolean;
    isRead?: boolean;
}

export const RowActions = <D extends object = any>({ row, actions, isVisible = false, isRead = false }: IRowActionsProps<D>) => {
    const visibleActions = actions.filter(action => {
        if (action.isVisible) {
            return action.isVisible(row);
        }
        return true;
    });

    if (visibleActions.length === 0) {
        return null;
    }

    const handleActionClick = (action: IRowAction<D>) => (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        
        const isDisabled = action.isDisabled ? action.isDisabled(row) : false;
        if (!isDisabled) {
            action.action(row);
        }
    };

    return (
        <S.RowActionsContainer className={`row-actions ${isVisible ? 'visible' : ''}`} $isRead={isRead}>
            {visibleActions.map((action, index) => {
                const isDisabled = action.isDisabled ? action.isDisabled(row) : false;
                
                return (
                    <Tooltip
                        key={index}
                        title={action.tooltip}
                        placement="top"
                        slots={{ transition: TooltipTransitionComponent }}
                        enterTouchDelay={0}>
                        <span>
                            <S.ActionButton
                                onClick={handleActionClick(action)}
                                disabled={isDisabled}
                                aria-label={action.tooltip}>
                                <Icon path={action.icon} size={0.67} />
                            </S.ActionButton>
                        </span>
                    </Tooltip>
                );
            })}
        </S.RowActionsContainer>
    );
};

